var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Users Grid")]),_c('ag-grid-vue',{staticClass:"ag-theme-balham default-grid",attrs:{"column-defs":_vm.userColumnDefs,"row-data":_vm.userRowData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }